import { FC } from 'react'

import WelcomePage from '@components/pages/Welcome/WelcomePage'

import PrivacyPolicyPage from '@/components/pages/Legal/PrivacyPolicyPage'
import TermsOfServicePage from '@/components/pages/Legal/TermsOfServicePage'
import CookiePolicyPage from '@/components/pages/Legal/CookiePolicyPage'

import KycIntroPage from '@components/pages/Kyc/KycIntroPage'
import KycVehiclePage from '@components/pages/Kyc/KycVehiclePage'
import KycVatPage from '@/components/pages/Kyc/KycVatPage'
import KycVehicleHowPage from '@components/pages/Kyc/KycVehicleHowPage'
import KycDetailsPage from '@components/pages/Kyc/KycDetailsPage'
import KycInsuranceStatusPage from '@components/pages/Kyc/KycInsuranceStatusPage'

import PasswordForgotPage from '@components/pages/Password/PasswordForgotPage'
import PasswordCodePage from '@components/pages/Password/PasswordCodePage'
import PasswordResetPage from '@components/pages/Password/PasswordResetPage'
import KycMfaPage from '@components/pages/Kyc/KycMfaPage'
import KycMfaCodePage from '@components/pages/Kyc/KycMfaCodePage'
import UserRegisterPage from '@components/pages/User/UserRegisterPage'
import UserLoginPage from '@components/pages/User/UserLoginPage'

import DashboardPage from '@/components/pages/Dashboard/DashboardPage'
import UserMfaCodePage from '@/components/pages/User/UserMfaCodePage'

import BoltTripsPage from '@/components/pages/Bolt/BoltTripsPage'
import BoltBalancePage from '@/components/pages/Bolt/BoltBalancePage'
import BoltIncomePage from '@/components/pages/Bolt/BoltIncomePage'
import BoltCommissionPage from '@/components/pages/Bolt/BoltCommissionPage'

import BoltBlockedPage from '@/components/pages/Bolt/BoltBlocked'
import BoltTripsHowPage from '@/components/pages/Bolt/BoltTripsHowPage'
import BoltReportHowPage from '@/components/pages/Bolt/BoltReportHowPage'
import BoltCommissionHowPage from '@/components/pages/Bolt/BoltCommissionHowPage'

import UberBalancePage from '@/components/pages/Uber/UberBalancePage'
import UberTripsPage from '@/components/pages/Uber/UberTripsPage'
import UberIncomePage from '@/components/pages/Uber/UberIncomePage'

import ExpensesCreatePage from '@/components/pages/Expenses/ExpensesCreatePage'
import ExpensesUpdatePage from '@/components/pages/Expenses/ExpensesUpdatePage'
import ExpensesDisclaimerPage from '@/components/pages/Expenses/ExpensesDisclaimerPage'

import KycVehicleTypePage from '@/components/pages/Kyc/KycVehicleTypePage'
import ExpensesMemoPage from '@/components/pages/Expenses/ExpensesMemoPage'
import DashboardYearPage from '@/components/pages/Dashboard/DashboardYearPage'
import DashboardExpensesPage from '@/components/pages/Dashboard/DashboardExpensesPage'
import DashboardIncomesPage from '@/components/pages/Dashboard/DashboardIncomesPage'
import DashboardVatMemoPage from '@/components/pages/Dashboard/DashboardVatMemo'
import DashboardTaxesPage from '@/components/pages/Dashboard/DashboardTaxesPage'
import IncomeUpdatePage from '@/components/pages/Income/IncomeUpdatePage'

import ProfilePage from '@/components/pages/Profile/ProfilePage'
import ProfileAccountPage from '@/components/pages/Profile/ProfileAccountPage'
import ExpensesPercentageInfoPage from '@/components/pages/Expenses/ExpensesPercentageInfoPage'
import ExpensesDocumentInfoPage from '@/components/pages/Expenses/ExpensesDocumentInfoPage'
import IncomeCreatePage from '@/components/pages/Income/IncomeCreatePage'

import HandbookJournalPage from '@/components/pages/Handbook/HandbookJournalPage'
import HandbookTaxesPage from '@/components/pages/Handbook/HandbookTaxesPage'
import HandbookAccountingPage from '@/components/pages/Handbook/HandbookAccountingPage'
import HandbookDocumentsPage from '@/components/pages/Handbook/HandbookDocumentsPage'

import BlogIndexPage from '@/components/pages/Blog/BlogIndexPage'
import BoltDriverAccountingPage from '@/components/pages/Blog/BoltDriverAccountingPage'
import CommissionVatPage from '@/components/pages/Blog/CommissionVatPage'
import DriverTaxesPage from '@/components/pages/Blog/DriverTaxesPage'
import ExpenseNormPage from '@/components/pages/Blog/ExpenseNormPage'
import AdvancedExpenseStrategyPage from '@/components/pages/Blog/AdvancedExpenseStrategyPage'
import FuelAccountingPage from '@/components/pages/Blog/FuelAccountingPage'
import TaxDeadlinesPage from '@/components/pages/Blog/TaxDeadlinesPage'
import VatChanges2025Page from '@/components/pages/Blog/VatChanges2025Page'
import WhatIsFinhudasPage from '@/components/pages/Blog/WhatIsFinhudasPage'
import FR0457FormPage from '@/components/pages/Blog/FR0457FormPage'
import AccountantVsFinhudasPage from '@/components/pages/Blog/AccountantVsFinhudasPage'
import Dac7VatPage from '@/components/pages/Blog/Dac7VatPage'
import ParkCostPage from '@/components/pages/Blog/ParkCostPage'
import TaxTrapsPage from '@/components/pages/Blog/TaxTrapsPage'
import TaxInstallmentPage from '@/components/pages/Blog/TaxInstallmentPage'
import CalculatorPage from '@/components/pages/Calculator/CalculatorPage'

interface RouteConfig {
  path: string
  component: FC
}

export const publicRoutes: RouteConfig[] = [
  {
    path: '/legal/terms-of-service',
    component: TermsOfServicePage
  },
  {
    path: '/legal/privacy-policy',
    component: PrivacyPolicyPage
  },
  {
    path: '/legal/cookie-policy',
    component: CookiePolicyPage
  },
  {
    path: '/blog',
    component: BlogIndexPage
  },
  {
    path: '/blog/bolt-apskaita-dokumentai',
    component: BoltDriverAccountingPage
  },
  {
    path: '/blog/atvirkstinis-pvm-pavezejams',
    component: CommissionVatPage
  },
  {
    path: '/blog/pavezejo-mokesciai-gpm-psd-vsd',
    component: DriverTaxesPage
  },
  {
    path: '/blog/individualios-veiklos-islaidos-30-procentu-arba-faktines',
    component: ExpenseNormPage
  },
  {
    path: '/blog/60-procentu-islaidos-strategija',
    component: AdvancedExpenseStrategyPage
  },
  {
    path: '/blog/kuro-apskaita-3-metodai-islaidos',
    component: FuelAccountingPage
  },
  {
    path: '/blog/mokesciu-kalendorius-kada-moketi-mokescius',
    component: TaxDeadlinesPage
  },
  {
    path: '/blog/pvm-pakeitimai-pavezejams-2025',
    component: VatChanges2025Page
  },
  {
    path: '/blog/kas-yra-finhudas-apskaitos-programa-pavezejams',
    component: WhatIsFinhudasPage
  },
  {
    path: '/blog/fr0457-automobilio-deklaravimas-vmi',
    component: FR0457FormPage
  },
  {
    path: '/blog/kodel-moketi-buhalteriui-40-eur',
    component: AccountantVsFinhudasPage
  },
  {
    path: '/blog/dac7-atvirkstinis-pvm-kaip-isvengti-baudu',
    component: Dac7VatPage
  },
  {
    path: '/blog/tikroji-darbo-per-parka-kaina',
    component: ParkCostPage
  },
  {
    path: '/blog/nematomi-mokesciu-spastai-bolt-vairuotojams',
    component: TaxTrapsPage
  },
  {
    path: '/blog/gpm-moketi-dalimis-mokestine-paskola',
    component: TaxInstallmentPage
  },
  {
    path: '/tax-calculator',
    component: CalculatorPage
  },
  {
    path: '/',
    component: WelcomePage,
  },
  {
    path: '/users/register',
    component: UserRegisterPage,
  },
  {
    path: '/users/login',
    component: UserLoginPage
  },
  {
    path: '/users/mfa',
    component: UserMfaCodePage
  },
  {
    path: '/password/forgot',
    component: PasswordForgotPage
  },
  {
    path: '/password/code',
    component: PasswordCodePage
  },
  {
    path: '/password/reset',
    component: PasswordResetPage
  },
]

export const kycRoutes: RouteConfig[] = [
  {
    path: '/',
    component: KycIntroPage
  },
  {
    path: '/kyc/intro',
    component: KycIntroPage,
  },
  {
    path: '/kyc/vehicle',
    component: KycVehiclePage,
  },
  {
    path: '/kyc/vat',
    component: KycVatPage
  },
  {
    path: '/kyc/vehicle/how',
    component: KycVehicleHowPage,
  },
  {
    path: '/kyc/vehicle/type',
    component: KycVehicleTypePage
  },
  {
    path: '/kyc/details',
    component: KycDetailsPage,
  },
  {
    path: '/kyc/insurance-status',
    component: KycInsuranceStatusPage,
  },
  {
    path: '/kyc/mfa',
    component: KycMfaPage
  },
  {
    path: '/kyc/mfacode',
    component: KycMfaCodePage
  },
]

export const dashboardRoutes: RouteConfig[] = [
  {
    path: '/legal/terms-of-service',
    component: TermsOfServicePage
  },
  {
    path: '/legal/privacy-policy',
    component: PrivacyPolicyPage
  },
  {
    path: '/legal/cookie-policy',
    component: CookiePolicyPage
  },
  {
    path: '/password/code',
    component: PasswordCodePage
  },
  {
    path: '/password/reset',
    component: PasswordResetPage
  },
  {
    path: '/kyc/details',
    component: KycDetailsPage,
  },
  {
    path: '/kyc/insurance-status',
    component: KycInsuranceStatusPage,
  },
  {
    path: '/handbook/journal',
    component: HandbookJournalPage
  },
  {
    path: '/handbook/taxes',
    component: HandbookTaxesPage
  },
  {
    path: '/handbook/accounting',
    component: HandbookAccountingPage
  },
  {
    path: '/handbook/documents',
    component: HandbookDocumentsPage
  },
  {
    path: '/',
    component: DashboardPage
  },
  {
    path: '/year',
    component: DashboardYearPage
  },
  {
    path: '/expenses',
    component: DashboardExpensesPage
  },
  {
    path: '/income',
    component: DashboardIncomesPage
  },
  {
    path: '/taxes',
    component: DashboardTaxesPage
  },
  {
    path: '/vat/memo',
    component: DashboardVatMemoPage
  },

  {
    path: '/bolt/balance',
    component: BoltBalancePage
  },
  {
    path: '/bolt/trips',
    component: BoltTripsPage
  },
  {
    path: '/bolt/blocked',
    component: BoltBlockedPage
  },
  {
    path: '/bolt/income',
    component: BoltIncomePage
  },
  {
    path: '/bolt/commission',
    component: BoltCommissionPage
  },
  {
    path: '/bolt/report/how',
    component: BoltReportHowPage
  },
  {
    path: '/bolt/commission/how',
    component: BoltCommissionHowPage
  },
  {
    path: '/bolt/trips/how',
    component: BoltTripsHowPage
  },
  {
    path: '/uber/balance',
    component: UberBalancePage
  },
  {
    path: '/uber/trips',
    component: UberTripsPage
  },
  {
    path: '/uber/income',
    component: UberIncomePage
  },
  {
    path: '/income/create',
    component: IncomeCreatePage
  },
  {
    path: '/income/update',
    component: IncomeUpdatePage
  },
  {
    path: '/expenses/disclaimer',
    component: ExpensesDisclaimerPage
  },
  {
    path: '/expenses/create',
    component: ExpensesCreatePage
  },
  {
    path: '/expenses/update',
    component: ExpensesUpdatePage
  },
  {
    path: '/expenses/memo',
    component: ExpensesMemoPage
  },
  {
    path: '/expenses/percentage/info',
    component: ExpensesPercentageInfoPage
  },
  {
    path: '/expenses/document/info',
    component: ExpensesDocumentInfoPage
  },

  {
    path: '/profile',
    component: ProfilePage
  },
  {
    path: '/profile/account',
    component: ProfileAccountPage
  }
]